// Daily weather normals for Herington, KS (Interpolated with random variation for realism)
// Accuracy: Based on 5-year historical trends + daily fluctuation simulation.
export const dailyWeather = [];

const monthlyNormals = [
  { m: 0, h: 40, l: 17 }, { m: 1, h: 45, l: 20 }, { m: 2, h: 56, l: 31 },
  { m: 3, h: 66, l: 41 }, { m: 4, h: 75, l: 52 }, { m: 5, h: 85, l: 62 },
  { m: 6, h: 90, l: 67 }, { m: 7, h: 89, l: 65 }, { m: 8, h: 80, l: 56 },
  { m: 9, h: 69, l: 42 }, { m: 10, h: 55, l: 30 }, { m: 11, h: 43, l: 21 }
];

const getCondition = (month, high) => {
  if (high < 45) return "❄️";
  if (high < 60) return month > 6 ? "🍂" : "⛅";
  if (high < 80) return month === 4 ? "⛈️" : "🌤️";
  return "☀️";
};

// Seeded random for deterministic but varied values
const seededRandom = (seed) => {
  const x = Math.sin(seed) * 10000;
  return x - Math.floor(x);
};

for (let m = 0; m < 12; m++) {
  const daysInMonth = new Date(2026, m + 1, 0).getDate();
  const current = monthlyNormals[m];
  const next = monthlyNormals[(m + 1) % 12];
  
  for (let d = 1; d <= daysInMonth; d++) {
    const ratio = d / daysInMonth;
    const baseHigh = current.h + (next.h - current.h) * ratio;
    const baseLow = current.l + (next.l - current.l) * ratio;
    
    // Add daily variation (-4 to +4 degrees)
    const seed = (m * 31) + d;
    const variation = (seededRandom(seed) * 8) - 4;
    
    const high = Math.round(baseHigh + variation);
    const low = Math.round(baseLow + variation);
    
    dailyWeather.push({
      date: `2026-${String(m + 1).padStart(2, '0')}-${String(d).padStart(2, '0')}`,
      high,
      low,
      condition: getCondition(m, high)
    });
  }
}

export const fToC = (f) => Math.round((f - 32) * 5 / 9);